module.exports = __webpack_public_path__ + "img/bpx-app.79a00d21.png";